//Investors.jsx
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import angelInvestorImage from '../assets/angel-investor.png'; // Import the image
import DownloadSection from '../components/DownloadSection';
import Header from '../components/Header';
import './Investors.css';

function Investors() {
    const { t } = useTranslation();

    // Scroll to top when the page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Create a ref for the DownloadSection
        const downloadRef = useRef(null);
    
        // Scroll function
        const scrollToDownload = () => {
            if (downloadRef.current) {
                downloadRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        };

    return (
        <div>
            {/* Pass scrollToDownload to Header */}
            <Header scrollToDownload={scrollToDownload} />

            <div className="investors-page">
                {/* Left Container with Image */}
                <div className="investors-image-container">
                    <img src={angelInvestorImage} alt="Angel Investor" className="angel-investor-image" />
                </div>

                {/* Right Content */}
                <div className="investors-container">
                    <h1>{t("investor.title")}</h1>
                    <h2>{t("investor.subtitle")}</h2>
                    <p>{t("investor.description")}</p>
                    <h2>{t("investor.opportunities")}</h2>
                    <p>{t("investor.opportunities_description")}</p>
                    <h2>{t("investor.contact_info")}</h2>
                    <p>{t("investor.contact_info_start")}</p>
                    <p><strong>{t("investor.contact_info_email")}</strong></p>
                    <p>{t("investor.contact_info_or")}</p>
                    <p><strong>{t("investor.contact_info_phone")}</strong></p>
                    <p>{t("investor.contact_info_end")}</p>
                </div>
            </div>

            {/* Wrap DownloadSection in a ref for scrolling */}
            <div ref={downloadRef} className="download-section-anchor">
                <DownloadSection />
            </div>
        </div>
    );
}

export default Investors;
